type QueryParams = Record<string, string | string[]>;

function getCurrentQueryParams(): QueryParams {
  const queryParams: QueryParams = {};

  new URLSearchParams(window.location.search).forEach((value, key) => {
    const currentValue = queryParams[key];

    if (Array.isArray(currentValue)) {
      currentValue.push(value);
      return;
    }

    if (typeof currentValue === "string") {
      queryParams[key] = [currentValue, value];
      return;
    }

    queryParams[key] = value;
  });

  return queryParams;
}

export function getPreRegTrackingPageData(): QueryParams {
  const pageData = getCurrentQueryParams();

  pageData.page_url = window.location.href;

  if (window.location.search) {
    pageData.query_string = window.location.search.substring(1);
  }

  return pageData;
}
